import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../hooks';

const LanguageSwitcher = React.memo(({ className = '' }) => {
  const { i18n } = useTranslation();
  const [, setLanguage] = useLocalStorage('language', 'nl');

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  return (
    <select
      className={`language-select ${className}`}
      value={i18n.language}
      onChange={(e) => changeLanguage(e.target.value)}
      aria-label="Select language"
    >
      <option value="nl">Nederlands</option>
      <option value="en">English</option>
    </select>
  );
});

LanguageSwitcher.displayName = 'LanguageSwitcher';

LanguageSwitcher.propTypes = {
  className: PropTypes.string,
};

export default LanguageSwitcher;
